import { useEffect } from "react";
import Menu from "../Menubar/Menu";
import AufgabenLaden from "./AufgabenLaden";
import { Categories } from "../MainMenu/MenüSicht";

var MonitorApi = require('monitor-api');


export function Aufgaben({ myApiClient, setSection }) {

    var hausaufgabenInstance = new MonitorApi.HausaufgabenApi(myApiClient);
    
    useEffect(() => {
        setSection('Aufgaben');
      }, [setSection]);

    return (
        <div className="next-to-menu">
            <Menu/>
            <Categories>
                <h1>Aufgaben</h1>

                <AufgabenLaden hausaufgabenInstance={hausaufgabenInstance}/>
                
            </Categories>
        </div>
    )
}
